import styled from 'styled-components';

export const StyledPrescriptionVisitTemplatesTextarea = styled.div`
   height: 144px;
`;

StyledPrescriptionVisitTemplatesTextarea.displayName = 'StyledPrescriptionVisitTemplatesTextarea';

export const StyledPrivateMedicalServicesSection = styled.div`
   margin-top: 32px;
`;

StyledPrivateMedicalServicesSection.displayName = 'StyledPrivateMedicalServicesSection';
